var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"video_or_image",class:{'modal-open': _vm.theModalStatus === true},style:(_vm.cssVars)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"video_or_image__inner"},[(_vm.video_source && _vm.video_poster && _vm.choice === 'video')?_c('div',{staticClass:"video_or_image__inner__video"},[_c('video-modal',{attrs:{"has_border":'no',"video_poster":_vm.video_poster,"video_source":_vm.video_source},on:{"isModalOpen":_vm.getModalData}})],1):_c('div',{staticClass:"video_or_image__inner__image"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"image"}}):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/VideoImage.vue